/* eslint-disable */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography } from "@mui/material";
import userRolesAndPermissions from "@/Services/userRolesAndPermissions.services";
import { useQuery, keyPressHandler } from "@/Helpers";
import { notificationServices } from "@/Services";
import { modalActions } from "@/Actions";
import useKeyPress from "@/Helpers/useKeyPress";
import DocumentsImagesSection from "../../Analytics/Inventory Analytics/PurchaseOrderList/DocumnetSection";
import { BackdropLoader } from "@/Components/Loaders";
import Info from "@/Components/InfoTab/Info";
import Tab from "@/Components/InfoTab/tab";
import VariantTable from "@/Pages/Food Products/VariantPrice/VariantTable";
import { DocumentModal } from "@/Pages/Analytics/Inventory Analytics/PurchaseOrderList/docModal";
import { ImageModal } from "@/Components/Modals/ImageModal";
import GrnHeader from "@/Pages/GRNPage/grnHeader";
import { urls } from "@/Constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import wastageAction from "@/Actions/wastage.action";
import departmentServices from "@/Services/DepartmentServices/departmentServices";
import moment from "moment";

const tabList = [
    {
        value: 'auditParameters',
        label: 'Field Parameters',
    },
    {
        value: 'documents',
        label: 'Documents',
    },
];

const COLUMNS = [
    { key: 'name', title: 'Parameter', width: 220 },
    { key: 'value', title: 'Recorded Value', width: 140 },
    { key: 'expectedValue', title: 'Expected Value', width: 140 },
    { key: 'range', title: 'Target Range', width: 160 },
    { key: 'status', title: 'Status', width: 120 },
    { key: 'images', title: 'Images', width: 140 },
];

const fieldMap = {
    'Audit ID': 'id',
    'Store': 'storeName',
    'Department': 'roleNames',
    'Username': 'userName',
    'Created At': 'createdAt',
};

function MyDepartmentsDetailPage() {
    const query = useQuery();
    const id = query.get('id');
    const history = useHistory();
    const dispatch = useDispatch();
    const listData = useSelector((state) => state.wastage.departmentsAuditList);
    const [idx, setIdx] = useState(-1);
    const [isLoading, setIsLoading] = useState(false);
    const [auditData, setAuditData] = useState([]);
    const [tabValue, setTabValue] = useState('auditParameters');
    const [summary, setSummary] = useState({});
    const departmentsData = useSelector((state) => state.wastage.departmentsList || []);
    const usersList = useSelector((state) => state.wastage.usersList || []);
    const storeList = useSelector((state) => state.form.STORES?.data?.LIST || []);
    const [documentsData, setDocumentsData] = useState([]);
    const keyPressed = useKeyPress();

    const fetchLabels = async () => {
        if (departmentsData.length === 0) {
            try {
                const response = await departmentServices.fetchDepartmentsList();
                if (response?.statusCode === 200) {
                    dispatch(wastageAction.setDepartmentsList(response?.data ?? []));
                }
            } catch (e) { console.error(e); }
        }
        if (usersList.length === 0) {
            try {
                const response = await userRolesAndPermissions.getUsersList();
                if (response?.statusCode === 200) {
                    dispatch(wastageAction.setUsersList(response?.data ?? []));
                }
            } catch (e) { console.error(e); }
        }
    };

    useEffect(() => {
        fetchLabels();
    }, []);

    useEffect(() => {
        if (listData?.length > 0) {
            const currentIndex = listData.findIndex(
                (item) => Number(item.id) === Number(id)
            );
            setIdx(currentIndex);
            const singleObj = listData[currentIndex];
            if (singleObj) {
                const store = (storeList || []).find(s => Number(s.id) === Number(singleObj.storeId));
                const dept = (departmentsData || []).find(d => Number(d.id) === Number(singleObj.roleId));
                const user = (usersList || []).find(u => Number(u.id) === Number(singleObj.createdBy));

                setSummary({
                    id: singleObj.id,
                    storeName: store?.name || 'N/A',
                    roleNames: dept?.userRole || 'N/A',
                    userName: user?.displayName || 'N/A',
                    status: singleObj.status,
                    createdAt: singleObj.createdAt,
                });
            }
        }
    }, [id, listData, departmentsData, storeList, usersList]);

    useEffect(() => {
        if (id) {
            fetchReport();
        }
    }, [id]);

    useEffect(() => {
        const auditData = listData?.[idx] ?? null;
        if (
            (keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
            auditData !== null
        ) {
            const newListItem = keyPressHandler(
                keyPressed,
                listData,
                idx
            );
            if (newListItem) {
                history.push({
                    pathname: `${urls.EXTENSION}${urls.DEPARTMENTS_DETAIL}`,
                    search: `id=${newListItem?.id}`,
                    state: {
                        from: history?.location?.state?.from,
                        search: history?.location?.state?.search,
                    },
                });
            }
        }
    }, [keyPressed]);

    const handleTabChange = (val) => {
        setTabValue(val);
        if (val === 'documents' && documentsData.length === 0) {
            fetchAuditDocuments();
        }
    };

    const fetchAuditDocuments = async () => {
        setIsLoading(true);
        try {
            const res = await departmentServices.fetchDepartmentsAuditReportPdf({
                params: { taskId: id },
            });
            if (res?.statusCode === 200 && res?.data?.base64) {
                setDocumentsData([{
                    id: 'audit-report',
                    name: 'Audit Report',
                    type: '.pdf',
                    url: `data:application/pdf;base64,${res?.data?.base64}`,
                    uploadedDate: summary?.createdAt || moment().format('YYYY-MM-DD hh:mm A'),
                    base64url: res?.data?.base64
                }]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewDoc = (document, documents) => {
        dispatch(modalActions?.toggleDocumentModal(true, {
            obj: document, list: documents
        }));
    };

    const fetchReport = async () => {
        setIsLoading(true);
        try {
            const res = await departmentServices.fetchDepartmentsAuditReport({
                params: { taskId: id },
            });
            if (res?.statusCode === 200) {
                setAuditData(res?.data);
            }
        } catch (error) {
            console.error("Error fetching report:", error);
            notificationServices.generateNotification({
                type: "error",
                message: "Failed to fetch audit report",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const navigateQC = (e) => {
        const type = e.currentTarget.dataset.type;
        let newListItem = null;

        if (type === 'next') {
            newListItem = listData?.[idx + 1];
        } else {
            newListItem = listData?.[idx - 1];
        }

        if (newListItem) {
            history.push({
                pathname: `${urls.EXTENSION}${urls.DEPARTMENTS_DETAIL}`,
                search: `?id=${newListItem?.id}`,
            });
        }
    };

    const handleViewImages = (images) => {
        dispatch(
            modalActions.toggleImageModal(true, {
                heading: 'Captured Images',
                image: images,
                width: '80%',
                height: '80%',
            })
        );
    };

    const SPECIAL_ITEMS = {
        value: (obj) => {
            const val = obj.value != null ? obj.value.toString().trim().toLowerCase() : null;
            const expected = obj.expectedValue != null ? obj.expectedValue.toString().trim().toLowerCase() : null;
            const hasRange = obj.min !== null || obj.max !== null;

            let isPass = false;
            let status = '-';

            if (hasRange) {
                const numVal = parseFloat(obj.value);
                isPass = !isNaN(numVal) &&
                    (obj.min === null || numVal >= parseFloat(obj.min)) &&
                    (obj.max === null || numVal <= parseFloat(obj.max));
                status = isPass ? 'Pass' : 'Fail';
            } else if (expected !== null) {
                isPass = val === expected;
                status = isPass ? 'Pass' : 'Fail';
            }

            return (
                <div className={`text-[13px] font-semibold ${status === 'Pass' ? 'text-green-700' : status === 'Fail' ? 'text-red-700' : 'text-gray-700'}`}>
                    {obj.value ?? '-'}
                </div>
            );
        },
        range: (obj) => {
            const hasRange = obj.min !== null || obj.max !== null;
            return (
                <div className="text-[13px] text-gray-600">
                    {hasRange ? `${obj.min ?? 'Min'} - ${obj.max ?? 'Max'}` : '-'}
                </div>
            );
        },
        status: (obj) => {
            const val = obj.value != null ? obj.value.toString().trim().toLowerCase() : null;
            const expected = obj.expectedValue != null ? obj.expectedValue.toString().trim().toLowerCase() : null;
            const hasRange = obj.min !== null || obj.max !== null;

            let isPass = false;
            let status = '-';

            if (hasRange) {
                const numVal = parseFloat(obj.value);
                isPass = !isNaN(numVal) &&
                    (obj.min === null || numVal >= parseFloat(obj.min)) &&
                    (obj.max === null || numVal <= parseFloat(obj.max));
                status = isPass ? 'Pass' : 'Fail';
            } else if (expected !== null) {
                isPass = val === expected;
                status = isPass ? 'Pass' : 'Fail';
            }

            if (status === '-') return <div className="text-gray-400 font-medium">-</div>;

            return (
                <div className="flex justify-start w-full">
                    <span
                        style={{
                            color: isPass ? '#166534' : '#991b1b',
                            background: isPass ? '#dcfce7' : '#fee2e2',
                            padding: '4px 12px',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 700,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minWidth: '70px',
                            textTransform: 'uppercase',
                        }}
                    >
                        {status}
                    </span>
                </div>
            );
        },
        images: (obj) => {
            if (!obj.imagesUrl?.length) return <div className="text-gray-400 font-medium">-</div>;
            return (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleViewImages(obj.imagesUrl)}
                    sx={{
                        textTransform: 'none',
                        fontSize: '11px',
                        py: 0.5,
                        px: 1,
                        borderColor: '#3b82f6',
                        color: '#3b82f6',
                        height: '26px',
                        '&:hover': {
                            borderColor: '#2563eb',
                            background: 'rgba(59, 130, 246, 0.05)',
                        },
                    }}
                >
                    View Images
                </Button>
            );
        },
        name: (obj) => <div className="text-[13px] font-medium text-gray-900">{obj?.name || '-'}</div>,
        expectedValue: (obj) => <div className="text-[13px] text-gray-600">{obj?.expectedValue ?? '-'}</div>,
    };

    const infoSpecialFields = {
        'Status': (id, status) => renderStatusBadge(status)
    };

    function renderStatusBadge(status) {
        let color = '#64748b';
        if (status === 'COMPLETED' || status === 'APPROVED') {
            color = '#166534';
        } else if (status === 'CANCELLED' || status === 'FAIL') {
            color = '#991b1b';
        } else if (status === 'PENDING') {
            color = '#64748b';
        }
        return (
            <div className="flex items-center gap-3">
                <span style={{
                    color,
                    fontSize: '18px',
                    fontWeight: 800,
                    textTransform: 'uppercase'
                }}>
                    {status || 'N/A'}
                </span>
            </div>
        );
    }

    if (!id) {
        return (
            <div className="flex items-center justify-center h-screen">
                <Typography variant="body1">Invalid Audit ID</Typography>
            </div>
        );
    }


    return (
        <div className="bg-white min-h-screen">
            <BackdropLoader showProgress isLoading={isLoading} />
            <DocumentModal />
            <ImageModal />

            <GrnHeader
                navigateQC={navigateQC}
                idx={idx}
                listData={listData}
                id={id}
                url={`${urls.EXTENSION}${urls.DEPARTMENTS_AUDIT}`}
                title='Back to Department Audit Logs'
                navigateLabel='Audit ID'
            />

            <div className='relative top-[3rem]'>

                {/* Info Section */}
                <Info
                    heading={{
                        key: 'Status',
                        value: renderStatusBadge(summary?.status)
                    }}
                    fieldMap={fieldMap}
                    data={summary}
                    specialFields={infoSpecialFields}
                />

                {/* Tabs Section */}
                <div className="mt-3 px-2">
                    <Tab
                        tabList={tabList}
                        tabValue={tabValue}
                        handleTabChange={handleTabChange}
                    />
                </div>
                {/* Content Section */}
                {tabValue === 'auditParameters' && (
                    <div className="h-[calc(100vh-300px)] m-2">
                        <VariantTable
                            columns={COLUMNS}
                            data={auditData}
                            customRowData={SPECIAL_ITEMS}
                            isLoading={isLoading}
                            customInfoLine="No audit records found for this task."
                        />
                    </div>
                )}

                {tabValue === 'documents' && (
                    <div className="flex-1 m-2 overflow-auto">
                        <DocumentsImagesSection
                            documents={documentsData}
                            handlePreview={handleViewDoc}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default MyDepartmentsDetailPage;